import { render, staticRenderFns } from "./article-list-items.vue?vue&type=template&id=b239148c&scoped=true"
import script from "./article-list-items.vue?vue&type=script&lang=js"
export * from "./article-list-items.vue?vue&type=script&lang=js"
import style0 from "./article-list-items.vue?vue&type=style&index=0&id=b239148c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b239148c",
  null
  
)

export default component.exports